import React from 'react';
import { T } from '@tolgee/react';
import { TrackingViewStatus } from '../orderTracking.interface';
import { LogoBlack } from '../../../../assets/LogoBlack';
import BouncingLoader from '../../../../components/BouncingLoader/BouncingLoader';

interface TrackingStateProps {
	status: Exclude<TrackingViewStatus, 'ready'>;
	canRetry: boolean;
	onRetry: () => void;
}

const TrackingState: React.FC<TrackingStateProps> = ({
	status,
	canRetry,
	onRetry,
}) => (
	<div className="fixed inset-0 flex flex-col items-center justify-center gap-6 bg-alabaster px-6 text-center">
		<LogoBlack />
		{status === 'loading' ? (
			<BouncingLoader />
		) : (
			<>
				<div className="flex flex-col gap-1">
					<h1 className="m-0 text-lg font-semibold text-track-ink">
						{status === 'invalid' ? (
							<T keyName="orderTracking.invalidTitle">Invalid link</T>
						) : (
							<T keyName="orderTracking.errorTitle">Couldn't load this order</T>
						)}
					</h1>
					<p className="m-0 max-w-md text-sm text-track-muted">
						{status === 'invalid' ? (
							<T keyName="orderTracking.invalidDescription">
								This tracking link is missing its access token. Please use the
								full link you were sent.
							</T>
						) : (
							<T keyName="orderTracking.errorDescription">
								The link may have expired or been revoked. Ask the sender for an
								updated link, or try again.
							</T>
						)}
					</p>
				</div>
				{canRetry ? (
					<button
						type="button"
						onClick={onRetry}
						className="h-9 px-4 rounded-lg bg-white border border-solid border-track-line text-sm font-semibold text-track-ink cursor-pointer transition hover:bg-track-hover"
					>
						<T keyName="orderTracking.tryAgain">Try again</T>
					</button>
				) : null}
			</>
		)}
	</div>
);

export default TrackingState;
